const stage = process.env.REACT_APP_ENV;

let environment;
switch (stage) {
  case 'production':
    environment = {
      STAGE: stage,
      SENTRY_DSN: '',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://jeno-api.insignia.academy/api/v1/',
        AUTH_HOST: 'https://auth-api.insignia.vc/api/v1/',
        SOCKET: 'https://jeno-ws.insignia.academy:4000',
      },
      ENABLE_SENTRY: true,
      GOOGLE_CLIENT_ID:
        '888739248668-o1lbiaj31eva75j5s5ecosaea92bapm1.apps.googleusercontent.com',
      LOGIN_URL: 'https://account.insignia.vc',
      STRIPE_PUBLIC_KEY:
        'pk_live_51IP30tHGLXolTouMSW14W2Zg7JGnL8a7gKNVZwa1amUjhdTDBgtLovT7L2pPD0oHMXDnusqHZAo6S2SRZuyQUiPy002R1HKdP3',
      URL: 'https://app.insignia.academy',
      ADMIN_URL: 'https://admin.insignia.academy',
    };
    break;

  case 'staging':
    environment = {
      STAGE: stage,
      SENTRY_DSN: '',
      API: {
        TIMEOUT: 60000,
        HOST: 'https://jeno-api-stage.insignia.academy/api/v1/',
        AUTH_HOST: 'https://auth-api-stage.insignia.vc/api/v1/',
        SOCKET: 'https://jeno-ws-stage.insignia.academy:4000',
      },
      ENABLE_SENTRY: true,
      GOOGLE_CLIENT_ID:
        '1055435200442-51nlj6g42niqldqu57vafq4rntm5ouei.apps.googleusercontent.com',
      LOGIN_URL: 'https://account-stage.insignia.vc',
      PDF_VIEWER_IFRAME_PREFIX: 'https://pdf.insignia.academy/?file_url=',
      STRIPE_PUBLIC_KEY:
        'pk_test_51IP30tHGLXolTouMZgh5y8pYcLjEdTbh73xTCJObWzTDurrcue11Ahq32yFkzTvCzFObEd7SoiBqk1etnQQUB0Wu00dlZgQlrf',
      URL: 'https://app-stage.insignia.academy',
      ADMIN_URL: 'https://jeno-admin-stage.insignia.academy',
    };
    break;

  case 'test':
  case 'development':
  default:
    environment = {
      STAGE: stage,
      SENTRY_DSN: '',
      API: {
        TIMEOUT: 60000,
        HOST: 'http://localhost:9010/api/v1/',
        AUTH_HOST: 'http://localhost:9000/api/v1/',
        SOCKET: 'https://jeno-ws-stage.insignia.academy:4000',
      },
      ENABLE_SENTRY: false,
      GOOGLE_CLIENT_ID:
        '1055435200442-51nlj6g42niqldqu57vafq4rntm5ouei.apps.googleusercontent.com',
      LOGIN_URL: 'https://account-stage.insignia.vc',
      STRIPE_PUBLIC_KEY:
        'pk_test_51IP30tHGLXolTouMZgh5y8pYcLjEdTbh73xTCJObWzTDurrcue11Ahq32yFkzTvCzFObEd7SoiBqk1etnQQUB0Wu00dlZgQlrf',
      URL: 'http://localhost:3000',
      ADMIN_URL: 'http://localhost:3010',
    };
    break;
}

export const ENV = environment;
